import React from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import BtnBack from '../../../../btn-back'
import LabelCustomSmall from '../../../../label-custom-small'
import { Image } from 'react-bootstrap'
import Muscle from './../../../../../images/Muscle.svg'
export default function EmpWelfareFitFirm() {
  return (
    <>
      <Card.Body className="overflow-auto">
        <BtnBack text={'สิทธิ Fit & Firm'} className={''} />
        <Row className="mt-3">
          <Col>
            <div className="d-flex">
              <Image
                src={Muscle}
                className="me-3"
                style={{
                  height: '45px',
                  width: '45px'
                }}
              ></Image>{' '}
              <span className="my-auto">มีสิทธิ 1,000 บาทต่อเดือน</span>
            </div>
          </Col>
          <Col xl={12}>
            <Row>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>ประเภท (รายเดือน/รายปี)</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>วันเริ่มต้น</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>วันสิ้นสุด</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>ราคาเต็มรวม Vat 7% (บาท)</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>ราคาที่บริษัทจ่าย (บาท)</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  )
}
